import { message } from 'antd';

export type DeeplinkErrorReason = 'permission_denied' | 'not_found' | 'offline' | 'obsolete' | 'invalid';

const messages: Record<DeeplinkErrorReason, { type: 'error' | 'warning'; text: string }> = {
  permission_denied: { type: 'error', text: 'Acesso negado à notificação.' },
  not_found: { type: 'error', text: 'Recurso não encontrado.' },
  offline: { type: 'warning', text: 'Você está offline. Tente novamente.' },
  obsolete: { type: 'warning', text: 'Recurso indisponível (removido ou arquivado).' },
  invalid: { type: 'error', text: 'Deeplink inválido.' },
};

export const toastService = {
  showDeeplinkError(reason: DeeplinkErrorReason): void {
    const payload = messages[reason] || messages.not_found;
    message[payload.type](payload.text);
  },
};
